import { Controller } from "@hotwired/stimulus";

// SAL-025: Copy a first email as it stands in the form (the person may have
// edited it): the subject, a blank line, the body. The status line says it
// worked, for screen readers too. Nothing is sent.
export default class extends Controller {
  static targets = ["subject", "body", "status"];
  static values = { done: String };

  async copy(event) {
    event.preventDefault();
    const subject = this.hasSubjectTarget ? this.valueOf(this.subjectTarget) : "";
    const body = this.hasBodyTarget ? this.valueOf(this.bodyTarget) : "";
    const text = [subject, body].filter((part) => part.length > 0).join("\n\n");
    try {
      await navigator.clipboard.writeText(text);
    } catch (_error) {
      const area = document.createElement("textarea");
      area.value = text;
      area.style.position = "fixed";
      area.style.opacity = "0";
      document.body.appendChild(area);
      area.select();
      document.execCommand("copy");
      area.remove();
    }
    if (this.hasStatusTarget) this.statusTarget.textContent = this.doneValue;
  }

  valueOf(element) {
    return "value" in element ? element.value : element.textContent.trim();
  }
}
